const PRIVATE_ROOM_NOT_FOUND_MESSAGE = 'Invalid room code. Please check and try again.';

/** Map API / socket errors to player-friendly private-room join copy. */
export function privateRoomJoinErrorMessage(apiMessage?: string | null): string {
  const msg = (apiMessage || '').trim();
  if (!msg) return PRIVATE_ROOM_NOT_FOUND_MESSAGE;

  const lower = msg.toLowerCase();
  if (
    lower === 'resource not found' ||
    lower === 'room not found or closed' ||
    lower.includes('private room not found') ||
    lower.includes('room not found')
  ) {
    return PRIVATE_ROOM_NOT_FOUND_MESSAGE;
  }

  return msg;
}
